export default __webpack_public_path__ + "static/media/popular.988e45f2.svg";